import React, { useState, useEffect } from "react";
import { Dropdown, Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { getStarColorClass, getRatingLabel } from '../../Functions/RatingLabelColor';

const FilterModal = ({ show, handleClose , filtertype, filterMethod ,filterValData, filterData }) => {


    const [selectedRating, setSelectedRating] = useState(null);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [visibleRows, setVisibleRows] = useState(2); // Pehle 2 rows dikhao
    const [itemsPerRow, setItemsPerRow] = useState(9); // Default value
    const [selectedProfessionals, setSelectedProfessionals] = useState([]);
    const [visibleProfessionalRows, setVisibleProfessionalRows] = useState(2);
    const [selectedProfessionalIDs, setSelectedProfessionalIDs] = useState([]);
    const [selectedAcademicIDs, setSelectedAcademicIDs] = useState([]);
    const [selectedAcademics, setSelectedAcademics] = useState([]);
    const [visibleAcademicRows, setVisibleAcademicRows] = useState(2);
    const [filterNData, setFilterNData] = useState(filterData);
    

    useEffect(() => {
        setFilterNData(filterData);
      }, [filterData]);
    
    
    const [ratings,setRatings]= useState([]);
    const [organizations,setOrganizations]= useState([]);
    const [professionals,setProfessionals]= useState([]);
    const [acadamincs,setAcadamincs]= useState([]);
    
    useEffect(() => {

       if(filterValData && filterValData.ratings)
            setRatings(filterValData.ratings);
        if(filterValData && filterValData.organizations)
            setOrganizations(filterValData.organizations);
        if(filterValData && filterValData.professionals)
            setProfessionals(filterValData.professionals)
        if(filterValData && filterValData.professionals)
            setProfessionals(filterValData.professionals)
        if(filterValData && filterValData.acadamincs)
            setAcadamincs(filterValData.acadamincs)

    }, [filterValData]);
    

    const academicList = Array.from({ length: 5 }, (_, i) => ({
        id: i + 1,
        name: `Academic ${i + 1}`,
    }));

    const toggleAcademicSelection = (item) => {
        const isSelected = selectedAcademicIDs.includes(item.id);
    
        const updatedAcademics = isSelected
            ? selectedAcademics.filter((a) => a.id !== item.id)
            : [...selectedAcademics, item];
        const updatedIDs = isSelected
            ? selectedAcademicIDs.filter((id) => id !== item.id)
            : [...selectedAcademicIDs, item.id];
    
        setSelectedAcademics(updatedAcademics);
        setSelectedAcademicIDs(updatedIDs);
    
        const typeFilterData = { ...filterNData, acadaminc: updatedIDs };
        setFilterNData(typeFilterData); // ✅ update filter data
    };
    

    // ✅ Dummy Professional Data
    const professionalList = Array.from({ length: 5 }, (_, i) => ({
        id: i + 1,
        name: `Professional ${i + 1}`,
    }));

  

    const resetFilters = () => {
        setSelectedRating(null);
        setSelectedTypes([]);
        setSelectedItems([]);
        setSelectedAcademics([]);
        setSelectedAcademicIDs([]);
        setSelectedProfessionals([]);
        setSelectedProfessionalIDs([]);
    };
    
 
    useEffect(() => {
        const updateItemsPerRow = () => {
            const width = window.innerWidth;
            if (width >= 1200) setItemsPerRow(5);
            else if (width >= 768) setItemsPerRow(4);
            else setItemsPerRow(2);
        };

        updateItemsPerRow();
        window.addEventListener("resize", updateItemsPerRow);
        return () => window.removeEventListener("resize", updateItemsPerRow);
    }, []);

    // ✅ Selection Function (ID + Name Select Hoga)
    const toggleProfessionalSelection = (item) => {
        const isSelected = selectedProfessionalIDs.includes(item.id);
    
        const updatedProfessionals = isSelected
            ? selectedProfessionals.filter((p) => p.id !== item.id)
            : [...selectedProfessionals, item];
        const updatedIDs = isSelected
            ? selectedProfessionalIDs.filter((id) => id !== item.id)
            : [...selectedProfessionalIDs, item.id];
    
        setSelectedProfessionals(updatedProfessionals);
        setSelectedProfessionalIDs(updatedIDs);
    
        const typeFilterData = { ...filterNData, professional: updatedIDs };
        setFilterNData(typeFilterData); // ✅ update filter data
    };

    const applyFilters = () => {
        filterMethod(filterNData);
        handleClose();
    };
    const [selectedRatings, setSelectedRatings] = useState([]);

    const toggleRating = (rating) => {
        setSelectedRatings((prev) => {
            const updatedRatings = prev.includes(rating.rate)
                ? prev.filter((r) => r !== rating.rate)
                : [...prev, rating.rate];
    
            const ratingsVal = updatedRatings.join(',');
            const typeFilterData = { ...filterNData, ratings: ratingsVal };
            setFilterNData(typeFilterData); // Update on both select & unselect
    
            return updatedRatings;
        });
    };
    const toggleOrganization = (item) => {
        setSelectedItems((prev) => {
            const updatedItems = prev.some((org) => org.id === item.id)
                ? prev.filter((org) => org.id !== item.id)
                : [...prev, item];
    
            //const selectedOrgIDs = updatedItems.map((org) => org.id);
            const typeFilterData = { ...filterNData, organization: JSON.stringify(updatedItems) };
            setFilterNData(typeFilterData); // 🔁 Update organization filter
    
            return updatedItems;
        });
    };
    
    
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title className="text-lg font-bold text-gray-900">Filter Reviews</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6 className="font-medium text-[18px] text-[#000] mb-1 leading-[1.4]">Ratings</h6>
                <div className="d-flex gap-2 flex-wrap">
            {ratings.map((rating,index) => (
                <span
                    key={index}
                    className={`flex items-center px-3 py-1 rounded-full text-xs font-medium border cursor-pointer 
                                    ${rating.total === 0 ? "cursor-not-allowed opacity-50 border-gray-300 bg-gray-100 text-gray-500" 
            : selectedRatings.includes(rating.rate)
                ? "border-blue-500 bg-gray-100 text-gray-700 cursor-pointer"
                : "border-gray-300 bg-white text-black cursor-pointer"
            }`}

                    onClick={rating.total === 0 ? null : () => toggleRating(rating)}
                >
                    {/* Star Icons */}
                    {[...Array(5)].map((_, starIdx) => (
                        <i
                            key={starIdx}
                            className={`fas fa-star mr-1 ${
                                starIdx < rating.rate ? getStarColorClass(rating.rate) : "text-gray-300"
                            }`}
                        ></i>
                    ))}
                    <span className="ml-2 text-gray-700">({rating.total})</span>
                </span>
            ))}
        </div>

                <h6 className="font-medium text-[18px] text-[#000] mb-1 mt-4 leading-[1.4]">Organizations</h6>
                <div className="d-flex gap-2 flex-wrap">
                    {organizations.map((item) => (
                        <span
                            key={item.id}
                            className={`flex items-center px-3 py-1 rounded-full text-xs font-medium border cursor-pointer ${selectedItems.includes(item) ? "border-blue-500 bg-gray-100 text-gray-700" : "border-gray-300 bg-white text-black"
                                }`}
                            onClick={() => {
                                toggleOrganization(item);
                            }}
                        >
                            <i className="fas fa-building mr-1 text-gray-500"></i>
                            {item.name}
                        </span>
                    ))}

                    {/* Load More Button */}
                    {visibleRows * itemsPerRow < organizations.length && (
                        <button
                            className="text-black font-bold text-sm cursor-pointer hover:bg-gray-200 px-2 py-1 rounded"
                            onClick={() => setVisibleRows((prev) => prev + 1)}
                        >
                            Load More
                        </button>
                    )}
                </div>

                <h6 className="font-medium text-[18px] text-[#000] mb-1 mt-4 leading-[1.4]">Professional Skills</h6>
                <div className="d-flex gap-2 flex-wrap">
                    {professionals.map((item) => (
                        <span
                            key={item.id}
                            className={`flex items-center px-3 py-1 rounded-full text-xs font-medium border cursor-pointer ${selectedProfessionalIDs.includes(item.id) ? "border-blue-500 bg-gray-100 text-gray-700" : "border-gray-300 bg-white text-black"
                                }`}
                            onClick={() => toggleProfessionalSelection(item)}
                        >
                            <i className="fas fa-user-tie mr-1 text-gray-500"></i>
                            {item.name}
                        </span>
                    ))}
                </div>

              

                <h6 className="font-medium text-[18px] text-[#000] mb-1 mt-4 leading-[1.4]">Academic Skills</h6>
                <div className="d-flex gap-2 flex-wrap">
                    {acadamincs.map((item) => (
                        <span
                            key={item.id}
                            className={`flex items-center px-3 py-1 rounded-full text-xs font-medium border cursor-pointer ${selectedAcademicIDs.includes(item.id) ? "border-blue-500 bg-gray-100 text-gray-700" : "border-gray-300 bg-white text-black"
                                }`}
                            onClick={() => toggleAcademicSelection(item)}
                        >
                            <i className="fas fa-graduation-cap mr-1 text-gray-500"></i>
                            {item.name}
                        </span>
                    ))}
                </div>

                

            </Modal.Body>
            <Modal.Footer className="flex justify-between items-center border-t pt-3">
                <p
                    className="text-gray-700 font-bold hover:text-base hover:bg-gray-200 px-3 py-1 hover:rounded-md cursor-pointer "
                    onClick={resetFilters}
                >
                    Reset
                </p>

                <Button
                    className="btn-explore-white"
                    onClick={applyFilters} 
                >
                    Apply
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FilterModal;
